import styled from 'styled-components';
import {
  Headline600Skin,
  Headline800Skin,
} from '../../atoms/Headline/HeadlineSkins';
import FilterFlag from '../../atoms/FilterFlag';
import CTA from '../../atoms/CTA';
import { mq } from '~/styles/grid';

export const Wrapper = styled.div`
  margin-bottom: 45px;
`;

export const SearchFlagsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 28px;
  align-items: flex-start;
`;

export const ResultText = styled.h1`
  ${Headline600Skin};
`;

export const ResultNumber = styled.span`
  ${Headline800Skin};
  font-weight: bold;
  margin-right: 0.3em;
`;

export const SearchFlagsBody = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (${(props) => props.theme.searchFlags.mobileSwitch}) {
    flex-direction: column;
    align-items: flex-start;
    margin-left: 0;
  }
`;

export const StyledFilterFlag = styled(FilterFlag)`
  margin-right: 15px;
  margin-bottom: 15px;
  flex-shrink: 0;

  @media (${(props) => props.theme.searchFlags.mobileSwitch}) {
    margin-right: 0;
    margin-bottom: 5px;
  }
`;

export const StyledCTA = styled(CTA)`
  @media (${(props) => props.theme.searchFlags.mobileSwitch}) {
    margin-top: 12px;
  }
  button {
    @media (${mq.mdUp}) {
      padding: 8px 0px;
    }
  }
`;
